import React, { useState, useEffect } from 'react';
import { Modal, Input, Space, Button, message } from 'antd';
import DepositApi from '../../../functions/api/booking/DepositApi';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const CaptureModal = ({ open, deposit, onClose, refresh }) => {
  const [amount, setAmount] = useState('');

  // Khi mở modal thì auto điền số tiền mặc định
  useEffect(() => {
    if (deposit) setAmount(deposit.deposit_amount || '');
  }, [deposit]);

  // ✅ Gọi API thu tiền
  const handleCapture = async () => {
    if (!deposit?.id) return;

    const rs = await DepositApi.captureAuthorization(deposit.id, amount);

    if (String(rs?.status || '').startsWith('2')) {
      message.success('✅ Thu tiền thành công');
      onClose();
      refresh();
    } else {
      message.error('❌ Thu tiền thất bại');
    }
  };

  // ✅ Hiển thị cảnh báo xác nhận trước khi gọi API
  const handleConfirmClick = () => {
    const num = Number(amount);
    const max = Number(deposit?.deposit_amount || 0);

    if (!num || isNaN(num) || num <= 0) {
      message.warning('Vui lòng nhập số tiền hợp lệ!');
      return;
    }

    if (num > max) {
      message.error(
        `❌ Số tiền vượt quá số tiền đặt cọc (${max.toLocaleString('vi-VN')})`
      );
      return;
    }

    confirm({
      title: 'Xác nhận thu tiền?',
      icon: <ExclamationCircleOutlined />,
      content: `Bạn có chắc muốn thu ${num.toLocaleString(
        'vi-VN'
      )} USD từ khách hàng này không?`,
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      centered: true,
      onOk: handleCapture,
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      title={`Thu tiền đặt cọc - ${deposit?.id || ''}`}
      destroyOnClose
      getContainer={false}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <label>
          <b>Số tiền cần thu</b>
        </label>
        <Input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="VD: 1000000"
        />
        <Space style={{ justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Hủy</Button>
          <Button type="primary" danger onClick={handleConfirmClick}>
            Xác nhận
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default CaptureModal;
